import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import ActualDate from "./ActualDate";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

const { Text, Link } = Typography;

const EventDetail = (props) => {
  const [visible, setVisible] = useState(false);
  const [actualDateDisplay, setActualDateDisplay] = useState(false);
  const [validationError, setValidationError] = useState({
    planError: null,
    actualError: null,
  });
  const [loginError, setLoginError] = useState(false);

  const [disabledBtn, setDisabledBtn] = useState(false);
  const [form] = Form.useForm();
  // const options = null;

  const checkFromAndToDateValidation = (fromDate, toDate) => {
    return toDate >= fromDate;
  };

  const handleChangeEvent = (e) => {
    const planFrom = form.getFieldValue("PlanSeriesFrom");
    const planTo = form.getFieldValue("PlanSeriesTo");
    const actualFrom = form.getFieldValue("ActualSeriesFrom");
    const actualTo = form.getFieldValue("ActualSeriesTo");

    let errorMsg = { planError: null, actualError: null };
    if (!checkFromAndToDateValidation(planFrom, planTo)) {
      errorMsg.planError = "`From Date` can't be greater then `To Date`";
    }
    if (
      actualFrom &&
      actualTo &&
      !checkFromAndToDateValidation(actualFrom, actualTo)
    ) {
      errorMsg.actualError = "`From Date` can't be greater then `To Date`";
    }
    setValidationError(errorMsg);
  };

  const handleCancel = (e) => {
    setVisible(false);
    setValidationError({ planError: null, actualError: null });
    props.modelCloseHandler();
  };

  const getGroupLabel = (values) => {
    const GroupID = values["groupid"];
    let group = props.items.filter((item) => item.key === GroupID);
    if (group.length > 0) {
      group = group[0];
      return group.value;
    }
    return null;
  };

  const onFinish = (values) => {
    setDisabledBtn(true);

    let error = false;
    let errorMsg = { planError: null, actualError: null };
    if (
      !checkFromAndToDateValidation(
        values["PlanSeriesFrom"],
        values["PlanSeriesTo"]
      )
    ) {
      error = true;
      errorMsg.planError = "`From Date` can't be greater then `To Date`";
    }
    if (
      values["ActualSeriesFrom"] &&
      values["ActualSeriesTo"] &&
      !checkFromAndToDateValidation(
        values["ActualSeriesFrom"],
        values["ActualSeriesTo"]
      )
    ) {
      error = true;
      errorMsg.actualError = "`From Date` can't be greater then `To Date`";
    }

    if (error) {
      setValidationError(errorMsg);
      setDisabledBtn(false);
      return;
    }

    const planData = {
      ...values,
      seriesFrom: values["PlanSeriesFrom"].format("YYYY/MM/DD"),
      seriesTo: values["PlanSeriesTo"].format("YYYY/MM/DD"),
    };
    const actualData = {
      ...values,
      seriesFrom: values["ActualSeriesFrom"]
        ? values["ActualSeriesFrom"].format("YYYY/MM/DD")
        : null,
      seriesTo: values["ActualSeriesTo"]
        ? values["ActualSeriesTo"].format("YYYY/MM/DD")
        : null,
    };

    // const newData = { ...values, seriesFrom: values["seriesFrom"].format("YYYY/MM/DD"), seriesTo: values["seriesTo"].format("YYYY/MM/DD") }
    let reqDat = [];
    let reqDat1 = {
      ...props.data,
      ...planData,
      plact: "plan",
      groupLabel: "Trg02",
    };
    delete reqDat1["PlanSeriesFrom"];
    delete reqDat1["PlanSeriesTo"];
    delete reqDat1["ActualSeriesFrom"];
    delete reqDat1["ActualSeriesTo"];
    reqDat1["groupLabel"] = getGroupLabel(values);

    reqDat.push(reqDat1);

    if (values["ActualSeriesFrom"] && values["ActualSeriesTo"]) {
      let reqDat2 = {
        ...props.data,
        ...actualData,
        plact: "actual",
        groupLabel: "Trg02",
      };
      delete reqDat2["PlanSeriesFrom"];
      delete reqDat2["PlanSeriesTo"];
      delete reqDat2["ActualSeriesFrom"];
      delete reqDat2["ActualSeriesTo"];
      reqDat2["groupLabel"] = getGroupLabel(values);
      reqDat.push(reqDat2);
    }

    if (props.isEdit) {
      liracrypt
        .patch("/calendar/event", reqDat)
        .then(({ data }) => {
          message.success("Event edit successfully !!", 4);
          setVisible(false);
          props.modelCloseHandler(reqDat);
          setDisabledBtn(false);
        })
        .catch(function (error) {
          console.log("Error****: fetch calendar", error);
          setDisabledBtn(false);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else {
      liracrypt
        .post("/calendar/event", reqDat)
        .then(({ data }) => {
          message.success("Event add successfully !!", 4);
          setVisible(false);
          props.modelCloseHandler(reqDat);
          setDisabledBtn(false);
        })
        .catch(function (error) {
          console.log("Error****: fetch calendar", error);
          setDisabledBtn(false);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              // ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  };

  useEffect(() => {
    if (props.visible) {
      setVisible(props.visible);
    }
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props]);
  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {props.visible ? (
          <Modal
            title={props.isEdit ? "Edit Event" : "Add Event"}
            open={visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            className={"ThemeModal"}
            width={960}
          >
            <div className="ThemeForm">
              <Form
                form={form}
                name="evntForm"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="horizontal"
                colon={false}
                onFinish={onFinish}
                size="large"
              >
                <Row gutter={24} justify="space-around" align="middle">
                  <Col span={12}>
                    <Form.Item
                      name="groupid"
                      label="Event"
                      rules={[
                        {
                          required: true,
                          message: "Please select Event",
                        },
                      ]}
                    >
                      <Select placeholder="Please select a group">
                        {props.items.map((item) => (
                          <Select.Option key={item.key} value={item.key}>
                            {item.value}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {/* <Form.Item
                                name="Name"
                                label="Name"
                                placeholder="Enter event name..."
                                rules={[
                                    { required: true, message: "Please input event name" },
                                    {
                                        max: 200,
                                        message: "Accept max 200 char",
                                    },
                                ]}
                            >
                                <Input placeholder="Enter event description..." />
                            </Form.Item> */}
                    <Form.Item
                      name="itemName"
                      label="Desc"
                      placeholder="Enter event description..."
                      rules={[
                        {
                          required: true,
                          message: "Please input event description",
                        },
                        {
                          max: 200,
                          message: "Accept max 200 char",
                        },
                      ]}
                    >
                      <Input placeholder="Enter event description..." />
                    </Form.Item>
                    <Form.Item
                      name="note"
                      label="Note"
                      placeholder="Enter event note..."
                      rules={[
                        { required: false },
                        {
                          max: 400,
                          message: "Accept max 400 char",
                        },
                      ]}
                    >
                      <Input placeholder="Enter event note..." />
                    </Form.Item>
                    {/* <Form.Item
                                name="seriesFrom"
                                label="From Date"
                                placeholder="Select From Date"
                                rules={[{ required: true }]}
                            >
                                <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select Plan Date" onChange={handleChangeEvent} />
                            </Form.Item>
                            <Form.Item
                                name="seriesTo"
                                label="To Date"
                                placeholder="Select From Date"
                                rules={[{ required: true }]}
                            >
                                <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select Plan Date" onChange={handleChangeEvent} />
                            </Form.Item> */}
                    <Form.Item
                      name="st"
                      label="Status"
                      placeholder="Select a Status"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Please select a status"
                        optionLabelProp="label"
                      >
                        <Select.Option key={"status_O"} value="O" label="Open">
                          <div
                            style={{
                              borderLeft: "5px solid",
                              borderColor: "#e74c3c",
                              paddingLeft: "10px",
                            }}
                          >
                            Open
                          </div>
                        </Select.Option>
                        <Select.Option key={"status_C"} value="C" label="Close">
                          <div
                            style={{
                              borderLeft: "5px solid",
                              borderColor: "#2ecc71",
                              paddingLeft: "10px",
                            }}
                          >
                            Close
                          </div>
                        </Select.Option>
                        <Select.Option key={"status_H"} value="H" label="Hold">
                          <div
                            style={{
                              borderLeft: "5px solid",
                              borderColor: "#3498db",
                              paddingLeft: "10px",
                            }}
                          >
                            Hold
                          </div>
                        </Select.Option>
                        <Select.Option
                          key={"status_X"}
                          value="X"
                          label="Cancelled"
                        >
                          <div
                            style={{
                              borderLeft: "5px solid",
                              borderColor: "#ecf0f1",
                              paddingLeft: "10px",
                            }}
                          >
                            Cancelled
                          </div>
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <p
                      style={{
                        marginTop: "0px",
                        color: "rgba(255, 255, 255, 0.65)",
                        fontSize: "18px",
                        marginBottom: "5px",
                      }}
                    >
                      Plan Dates:
                    </p>
                    {validationError.planError ? (
                      <Text type="danger">{validationError.planError}</Text>
                    ) : null}
                    <Form.Item
                      name="PlanSeriesFrom"
                      label="From Date"
                      placeholder="Select Plan From Date"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <DatePicker
                        className="gx-mb-3 gx-w-100 custom-blue-bg-color"
                        placeholder="Select Plan from Date"
                        onChange={handleChangeEvent}
                      />
                    </Form.Item>
                    <Form.Item
                      name="PlanSeriesTo"
                      label="To Date"
                      placeholder="Select Plan to Date"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <DatePicker
                        className="gx-mb-3 gx-w-100 custom-blue-bg-color"
                        placeholder="Select Plan to Date"
                        onChange={handleChangeEvent}
                      />
                    </Form.Item>
                    <ActualDate
                      display={props.isEdit}
                      handleChangeEvent={handleChangeEvent}
                      validationError={validationError}
                    />
                  </Col>

                  {/* <Form.Item
                                name="seriesFrom"
                                label="From Date"
                                placeholder="Select From Date"
                                rules={[{ required: true }]}
                            >
                                <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select Plan Date" />
                            </Form.Item>
                            <Form.Item
                                name="seriesTo"
                                label="To Date"
                                placeholder="Select From Date"
                                rules={[{ required: true }]}
                            >
                                <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select Plan Date" />
                            </Form.Item> */}

                  <div className="formBtnGroupDiv">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button gx-mt-1 bigBtn"
                      disabled={disabledBtn}
                    >
                      {"Submit"}
                    </Button>
                  </div>
                </Row>
              </Form>
            </div>
          </Modal>
        ) : null}
      </React.Fragment>
    </>
  );
};

export default EventDetail;
